/* PDP rating row → reviews section. Smooth scroll without setting
   scroll-behavior on <html>, which would also animate the PLP's infinite
   scroll restores and the search drawer's jumps. */
document.addEventListener('click', (e) => {
  const a = e.target.closest('[data-aes-to-reviews]');
  if (!a) return;
  const t = document.getElementById('aes-reviews');
  if (!t) return;
  e.preventDefault();
  t.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
